module.exports = __webpack_public_path__ + "img/image105.21924f1d.png";